document.querySelectorAll(".video").forEach(function (el) {
    if(el.querySelector("[data-play-toggle]")){
        const playButton = el.querySelector("[data-play-toggle]");
        const iframe = el.querySelector("iframe");
        
        const playVideo = (ev) => {
            ev.preventDefault();
            el.classList.add('playing');
            
            let url = iframe.getAttribute("src");
            const separator = url.includes('?') ? '&' : '?';
            iframe.setAttribute("src", url + separator + "autoplay=1");
            
            setTimeout(() => {
                iframe.focus();
            }, 100);
        };
        
        playButton.addEventListener("click", playVideo);
        playButton.addEventListener("keydown", (ev) => {
            if (ev.key === 'Enter' || ev.key === ' ') {
                playVideo(ev);
            }
        });
    }
});